import styles from "./styles.module.css";
import Head from "next/head"
import { getImageFromClippingList } from "@/shared/functions/getImagesFunctions";
import ImgCarousel from "./components/ImgCarousel";
import VideoViewer from './components/VideoViewer';
import { ArrowLeft, ArrowRight } from "@/icons/index";
import { VideoIcon } from "@/icons/components/Video";
import { CameraIcon } from "@/icons/components/Camera";

const stripHtml = (html) => html ? html.replace(/<[^>]*>/g, '').trim() : '';

const Multimedia = ({ content }) => {

  const CROP = "3_2_300x200";

  let firstMultimedia = null;
  let multimedia = content;

  if (content.length > 0) {
    firstMultimedia = content[0];
    multimedia = content.slice(1);
  }

  const buildElement = (el) => {
    let element;
    const { _id, title, url } = el;
    if (el.images) {
      const { summary, images } = el;
      const { value: { clippings } } = images[0];
      const { domain, imgUrl } = getImageFromClippingList(clippings, CROP);

      element = {
        _id,
        title,
        summary: stripHtml(summary),
        url: `/gallery${url}`,
        img: `${domain}${imgUrl}`,
      };

    } else if (el.thumbnail) {
      const { thumbnail, tags } = el;

      element = {
        _id,
        title,
        url,
        summary: tags[0].name,
        img: thumbnail,
      };
    }
    return element;
  };

  return (
    <>
      <Head>
        <link rel="preload" href="/api/list/top-gallery" as="fetch" crossOrigin="anonymous"></link>
        <link rel="preload" href="/api/list/column-lilanews" as="fetch" crossOrigin="anonymous"></link>
        <link rel="preload" href="/api/list/bottom-gallery" as="fetch" crossOrigin="anonymous"></link>
      </Head>
      {firstMultimedia && firstMultimedia.images && firstMultimedia.images.length > 0 &&
        <ImgCarousel {...firstMultimedia} />
      }
      {firstMultimedia && firstMultimedia.videoFiles &&
        <VideoViewer {...firstMultimedia} />
      }
      <ul className={styles["grid"]}>
        {multimedia.map((el) => {
          const element = buildElement(el);
          if (element) {
            const { _id, title, summary, url, img } = element;

            return (
              <li className={styles["grid-card"]} key={_id}>
                <a href={url}>
                  <img className={el.images ? styles["grid-card-img"] : styles["grid-card-thumb"]} src={img} alt={title} loading="lazy" />


                  {el.images && (
  <div className={styles['icon-container']}>
    <CameraIcon className={styles["video-icon"]} />
  </div>
)}

{el.thumbnail && !el.images && (
  <div className={styles['icon-container']}>
    <VideoIcon className={styles["video-icon"]} />
  </div>
)}

                  <div className={styles["grid-card-body"]}>
                    <div className={styles["grid-card-body-title"]}>{summary}</div>
                    <div className={styles["grid-card-body-summary"]}>{title}</div>
                  </div>
                </a>
              </li>
            );
          }
        })}
      </ul>
    </>
  );
};

export default Multimedia;
